import ITable from "../../interfaces/ITable";

const telaTabelaCabecalho = (abaSelecionada: string, tipo: string, keySelecionadaTelaObjetos = '') : ITable[]=> {

    const classCkeckbox = (abaSelecionada === 'analitico' && (tipo === 'N' || tipo === 'F')) ? 'text-center' : 'text-center d-none';
    const checkbox = { label: "checkbox-cabecalho", accessor: "check", sortable: false, className: classCkeckbox, classNameData: "text-center" };

    let cabecalho_base = [{ label: "SE", accessor: "seOrigem", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Origem", accessor: "uniOrigem", sortable: true, className: "text-left", classNameData: "text-left" },
    { label: "Enviado", accessor: "dataExpedicao", sortable: true, className: "text-center" , classNameData: "text-center"},
    { label: "Recebido", accessor: "dataRecebido", sortable: true, className: "text-center" , classNameData: "text-center"},
    { label: "Englobador", accessor: "numUnitizador", sortable: true, className: "text-center", classNameData: "text-center" }
];

//Se aba Faltantes selecionada na tela objetos incluir a coluna Transferido após coluna Recebido
if(abaSelecionada === 'analitico' && keySelecionadaTelaObjetos === 'faltante') cabecalho_base.splice(4,0,{ label: "Transferido", accessor: "dataAlterado", sortable: true, className: "text-center" , classNameData: "text-center"});
//Se aba Excluídos selecionada na tela objetos incluir a coluna Excluído após coluna Recebido
if(abaSelecionada === 'analitico' && keySelecionadaTelaObjetos === 'excluido') cabecalho_base.splice(4,0,{ label: "Data Exclusão", accessor: "dataAlterado", sortable: true, className: "text-center" , classNameData: "text-center"},{ label: "Motivo Exclusão", accessor: "motivo", sortable: true, className: "text-left" , classNameData: "text-left"},{ label: "Matrícula", accessor: "matricula", sortable: true, className: "text-center" , classNameData: "text-center"});

const complemento_cabecalho_sintetico = [
    { label: "Objetos", accessor: "qtdObjetos", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Trat. Local", accessor: "qtdObjetosConferidosLocal", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Trat. Nacional", accessor: "qtdObjetosConferidosNacional", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Pendentes", accessor: "qtdObjetosPendentes", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Faltantes", accessor: "qtdObjetosFaltantes", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Excluídos", accessor: "qtdObjetosExcluidos", sortable: true, className: "text-center", classNameData: "text-center" }
];

if(abaSelecionada === 'sintetico') return [...cabecalho_base, ...complemento_cabecalho_sintetico];

const complemento_cabecalho_analitico_todos = [
    { label: "Objeto", accessor: "objeto", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Prazo", accessor: "dataMaximaPrazo", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Carga", accessor: "carga", sortable: true, className: "text-center", classNameData: "text-center" }
];

if(abaSelecionada === 'analitico' && tipo === 'N') return [...cabecalho_base, ...complemento_cabecalho_analitico_todos,checkbox];

const complemento_cabecalho_analitico_faltante = [
    { label: "Data Faltante", accessor: "dataAlterado", sortable: true, className: "text-center", classNameData: "text-center" }
];

if(abaSelecionada === 'analitico' && tipo === 'F') return [...cabecalho_base, ...complemento_cabecalho_analitico_todos,...complemento_cabecalho_analitico_faltante,checkbox];

const complemento_cabecalho_excluidos_analitico = [
    { label: "Exclusão", accessor: "dataAlterado", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Matrícula", accessor: "matricula", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Motivo", accessor: "motivo", sortable: true, className: "text-center", classNameData: "text-center" }
];

//Excluídos
return [...cabecalho_base, ...complemento_cabecalho_analitico_todos,  ...complemento_cabecalho_excluidos_analitico];

};


export default telaTabelaCabecalho;
